import { Menu, LogOut } from 'lucide-react'
import { useLogout } from '@/features/auth/useAuth'
import type { CurrentUser } from '@/features/auth/api'

export function Navbar({ user, onToggleSidebar }: { user: CurrentUser; onToggleSidebar?: () => void }) {
  const logoutMutation = useLogout()
  return (
    <header className="h-14 px-4 sm:px-6 flex items-center gap-3 bg-white border-b border-ink-rule">
      <button
        onClick={onToggleSidebar}
        className="lg:hidden text-ink-soft hover:text-ink p-2 -ml-2"
        aria-label="toggle sidebar"
      >
        <Menu size={20} strokeWidth={1.5} />
      </button>

      <div className="ml-auto flex items-center gap-3 text-sm">
        <div className="hidden sm:flex flex-col items-end leading-tight">
          <span className="text-ink font-medium">
            {user.fname} {user.lname}
          </span>
          <span className="text-[11px] text-ink-mute">
            {user.type === 'admin' ? 'ผู้ดูแลระบบ' : 'ผู้สมัครสอบ'}
          </span>
        </div>
        <button
          onClick={() => logoutMutation.mutate()}
          disabled={logoutMutation.isPending}
          className="btn-ghost"
          title="ออกจากระบบ"
        >
          <LogOut size={16} strokeWidth={1.5} />
          <span className="hidden sm:inline">ออกจากระบบ</span>
        </button>
      </div>
    </header>
  )
}
